/* eslint-disable jsx-a11y/anchor-is-valid */
import { ReactElement } from 'react';
import DropdownItem from './DropdownItem';

interface Item {
  icon: string;
  title: string;
  action: () => void;
  active?: boolean;
}

interface Props {
  element: ReactElement;
  itens: Item[];
  itemBottom?: Item;
}

const Dropdown = ({ element, itens, itemBottom }: Props) => (
  <>
    <span
      className="nav-link dropdown-toggle"
      role="button"
      id="user-dropdown"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="true"
    >
      {element}
    </span>
    <div
      className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
      aria-labelledby="user-dropdown"
    >
      {itens.map((item) => (
        <DropdownItem
          key={`${item.icon}-${item.title}`}
          icon={item.icon}
          title={item.title}
          action={item.action}
          active={item.active}
        />
      ))}

      {itemBottom && (
        <>
          <div className="dropdown-divider" />

          <DropdownItem
            icon={itemBottom.icon}
            title={itemBottom.title}
            action={itemBottom.action}
          />
        </>
      )}
    </div>
  </>
);

Dropdown.defaultProps = {
  itemBottom: undefined,
};

export default Dropdown;
